var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSeturSmall = function SvgSeturSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.288 23.437c-4.184-3.017-11.383-4.947-11.383-4.947l-.943 5.566-8.455-9.962 11.27-6.687-.979 5.803c3.74.498 7.861 2.454 10.398 3.686l1.033.503 2.223-13.18c-.315-.174-.657-.339-.98-.51C31.666 1.616 27.574.434 23.125.08 12.28-.76.98 4.966.047 16.737c-.417 5.204 1.984 8.98 5.707 11.451 5.079 2.95 13.761 4.684 13.761 4.684l.89-5.69 8.484 9.964-11.25 6.706.928-5.457c-6.88-.718-13.1-3.726-16.025-5.555L.118 46.984C4.771 49.1 10.081 50.54 14.9 50.907c10.779.852 22.086-4.148 23.023-15.98.41-5.174-1.415-8.872-4.634-11.49Z",
    fill: "#E83843"
  })));
};
export default SvgSeturSmall;